import gql from 'graphql-tag';

export default gql`
  query CrossingsData {
    quote @rest(
      type: "Quote"
      path: "Reservations/ViewQuote"
      method: "GET"
    ) {
      campsiteBookings {
          id
          campsite {
            id
            name
            address {
              country
              county
              addressLines
              postCode
            }
            siteCode
            type
          }
          pitches {
            id
            code
            type
            bookingDates {
              fromDate
              toDate
            }
            numNights
            errata
            basePrice
            totalPrice
            guests
            partyMemberReference
            supplements
            isNonRefundable
        }
        outfit {
          externalId
          id
          towHeight
          towLength
          towType
          towMake
          towModel
          vehicleHeight
          vehicleLength
          vehicleMake
          vehicleModel
          vehicleReg
          vehicleType
        }
        extras
        partyMembers
        quoteId
      }
    }
  }
`;
